module.exports = __webpack_public_path__ + "img/taicangyh.97951508.png";